<template>
  <v-row
    no-gutters
    align="start"
    justify="center"
    style="height: 100%; max-width: 100% !important"
  >
    <v-col>
      <v-card>
        <v-tabs v-model="activeTab">
          <v-tab href="#tags">{{ $t("management.tag.title") }}</v-tab>
          <v-tab href="#mentorship-actions">{{
            $t("mentorship.actions.title")
          }}</v-tab>
          <v-tab href="#mentorship-feedback">{{
            $t("management.mentorship.feedback.title")
          }}</v-tab>
          <v-tab href="#mentorship-ignore">{{
            $t("management.mentorship.ignore.title")
          }}</v-tab>
          <v-tab
            href="#all-employees"
            v-if="role('admin', 'safetyRepresentative')"
            >{{ $t("management.allEmployees.title") }}</v-tab
          >
          <v-tab href="#modes">{{ $t("management.modes.title") }}</v-tab>
          <v-tab href="#health-hazards">{{
            $t("management.healthHazards.title")
          }}</v-tab>
          <v-tab href="#tool-check-results">{{
            $t("management.toolCheckResults.title")
          }}</v-tab>
          <v-tab href="#settings">{{ $t("management.settings.title") }}</v-tab>
        </v-tabs>
      </v-card>
      <v-tabs-items v-model="activeTab" touchless>
        <v-tab-item value="tags">
          <tag />
        </v-tab-item>
        <v-tab-item value="mentorship-actions">
          <mentorship-actions />
        </v-tab-item>
        <v-tab-item value="mentorship-feedback">
          <mentorship-feedback />
        </v-tab-item>
        <v-tab-item value="mentorship-ignore">
          <mentorship-ignore />
        </v-tab-item>
        <v-tab-item
          v-if="role('admin', 'safetyRepresentative')"
          value="all-employees"
        >
          <all-employees />
        </v-tab-item>
        <v-tab-item value="modes">
          <modes />
        </v-tab-item>

        <v-tab-item value="health-hazards">
          <health-hazards />
        </v-tab-item>

        <v-tab-item value="tool-check-results">
          <tool-check-results />
        </v-tab-item>

        <v-tab-item value="settings">
          <app-settings />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import Tag from "@/components/management/Tag.vue";
import MentorshipActions from "@/components/management/MentorshipActions.vue";
import MentorshipFeedback from "@/components/management/MentorshipFeedback.vue";
import MentorshipIgnore from "@/components/management/MentorshipIgnore.vue";
import AllEmployees from "@/components/management/AllEmployees.vue";
import Modes from "@/components/management/Modes.vue";
import AppSettings from "@/components/management/AppSettings.vue";
import HealthHazards from "@/components/management/HealthHazards.vue";
import ToolCheckResults from "@/components/management/ToolCheckResults.vue";

export default {
  components: {
    Tag,
    MentorshipActions,
    MentorshipFeedback,
    MentorshipIgnore,
    AllEmployees,
    Modes,
    AppSettings,
    HealthHazards,
    ToolCheckResults,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["role"]),
    activeTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        this.$router.replace({ query: query });
      },
      get() {
        return this.$route.query.tab || "tags";
      },
    },
  },
};
</script>

<style scoped>
.v-tabs-items {
  background-color: transparent !important;
}
</style>
